import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import About from "./About";
import AboutSlider from "./AboutSlider";
import JobHere from "./JobHere";
import JobHiring from "./JobHiring";
import JobHomeSection from "./JobHomeSection";
import Newsletter from "../common/Newsletter";
import Step from "./Step";
import Categories from "../common/Categories";
import LogoSection from "../common/LogoSection";

const JobDemo1Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <JobHomeSection />
      <LogoSection type="job_demo1" />
      <JobHere />
      <Step />
      <Categories type="job_demo1" />
      <JobHiring />
      <About />
      <AboutSlider />
      <Newsletter type="job_demo1" />
    </>
  );
};

export default JobDemo1Container;
